export default __webpack_public_path__ + "images/bottle-stone-6.svg";